export const API_ENDPOINTS = {
 
  GET_DISTRIBUTORS:(userId: string) => `/partners/${userId}/distributors`,

  MAPPED_DISTRIBUTORS: (userId: string) => `/users/${userId}/distributors`,

  FETCH_AVAILABLE_NUMBERS :(userId:string)=> `/users/${userId}/available-certificate-numbers`,


  ISSUE_CERTIFICATE: '/certificates',
  // Certificate Details
  GET_CERTIFICATE_DETAILS: (requestId: string) => `/certificates/${requestId}`,

  CERTIFICATES_PRESIGNED_URL: '/certificates/presigned-url',

  // Request Details Page
  GET_CERTIFICATE_REQUEST_DETAILS: (requestId: string) => `/certificate-requests/${requestId}`,
  UPDATE_CERTIFICATE_REQUEST_STATUS: '/certificate-requests/status',

  // Request Certificate Page
  GET_LICENSE_PRESIGNED_URL: (
    fileName: string,
    fileType: string,
    partnerId: string | null,
    timestamp: number
  ) =>
    `/license/presigned-url?fileName=${fileName}&fileType=${fileType}&partnerId=${partnerId}&time_stamp=${timestamp}`,
  CREATE_CERTIFICATE_REQUEST: '/certificate-requests',

  GET_DISTRICTS: (countryCode: string, stateCode: string | null) =>
    `/locations/districts?countryCode=${countryCode}&stateCode=${stateCode}`,
  
  GET_PRODUCTS: (partnerId: string | null, countryCode: string, districtCode: string | number, stateCode: string) =>
    `/partners/${partnerId}/products/uncertified?countryCode=${countryCode}&districtCode=${districtCode}&stateCode=${stateCode}`,

  // App Component
  GET_USER_DETAILS: (cwid: string, countryCode: string) => `/users/${cwid}?countryCode=${countryCode}`,
  SEARCH_PARTNER_BY_ID: (partnerId: string) => `/partners/${partnerId}`,

  // Certificate Requests for both Admin and Partner
  GET_USER_CERTIFICATE_REQUESTS: (
    userId: string | null,
    status: string,
    searchBy: string,
    page: number,
    size: number,
    userRole: string
  ) => `/users/${userId}/certificate-requests?status=${status}&searchBy=${searchBy}&page=${page}&size=${size}&userRole=${userRole}`,

  // Certificate Requests for Partner
  GET_PARTNER_CERTIFICATE_REQUESTS: (partnerId: string | null, page: number, size: number) =>
    `/partners/${partnerId}/certificate-requests?page=${page}&size=${size}`,

  CERTIFICATE_REQUESTS_REJECT:(requestId:string)=> `/certificate-requests/${requestId}/reject`,
  UPDATE_SHOPNAME: (partnerId: string, shopName: string) => `/partners/${partnerId}/shop-name?shopName=${shopName}`,

  CERTIFICATE_REQUESTS_DELIVER:(requestId:string)=> `/certificate-requests/${requestId}/deliver`,

  APPROVE_CERTIFICATE_REQUEST:(requestId:string)=> `/certificate-requests/${requestId}/approve`,

  UPDATE_HANDOVER_STATUS:(requestId:string, status:string)=> `/certificate-requests/${requestId}/delivery-status?status=${status}`,

  USER_MANAGERS: (userId: string) => `/users/${userId}/squad-lead`,

  APPROVED_REQUESTS_BY_ISSUER: (userId: string) => `/issuers/${userId}/approved-requests`,

};